import React, { useContext } from "react";
import { MainContext } from "../../contexts/MainContext";
import usePushNotifications from "../../utils/usePushNotifications";

const MiddlewareWrapper = ({ children }) => {
  const { jwtToken, currentGroupId, setDeviceToken } = useContext(MainContext);
  usePushNotifications({ jwtToken, currentGroupId, setDeviceToken });

  return <>{children}</>;
};

export default MiddlewareWrapper;
